module.exports = "query Procedures($ids: [ID]) {\n  procedures(ids: $ids) {\n    id\n    name\n    description\n  }\n}"